<template>
    <transition name="back-to-top-fade">
        <v-flex
            class="vue-back-to-top"
            v-show="visible"
            :style="`bottom:${this.bottom};right:${this.right};`"
            data-qe-id="back-to-top_btn"
            @click="backToTop">
            <v-flex class="circle-button">
                <v-tooltip slot="append" top>
                    <i slot="activator"  class="fas fa-chevron-up"></i>
                    <span>{{appCommonConstants.BACK_TO_TOP}}</span>
                </v-tooltip>
            </v-flex>
        </v-flex>
    </transition>
</template>

<script>
    import { appCommonConstants } from '@/components/appCommon.constants.js';

    export default {
        name: 'BackToTop',
        data() {
            return {
                appCommonConstants,
                isBackTopFooter: false,
                visible: false,
                scrollIndentBackTop: 0,
                scrollHeight: 0,
                visibleoffset: 600,
                visibleoffsetbottom: 0,
            };
        },
        props: {
            right: {
                type: String,
                default: '20px',
            },
            bottom: {
                type: String,
                default: '80px',
            },
        },
        mounted() {
            window.smoothscroll = () => {
                const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
                if (currentScroll > 0) {
                    window.requestAnimationFrame(window.smoothscroll);
                    window.scrollTo(0, Math.floor(currentScroll - (currentScroll / 5)));
                }
            };
            window.addEventListener('scroll', this.catchScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.catchScroll);
        },
        methods: {
            catchScroll() {
                const pastTopOffset = window.pageYOffset > parseInt(this.visibleoffset, 10);
                const pastBottomOffset = window.innerHeight + window.pageYOffset >= document.body.offsetHeight - parseInt(this.visibleoffsetbottom, 10);
                this.visible = parseInt(this.visibleoffsetbottom, 10) > 0 ? pastTopOffset && !pastBottomOffset : pastTopOffset;
                this.scrollFn(this);
            },
            backToTop() {
                window.smoothscroll();
                this.$emit('scrolled');
            },
            scrollFn() {
                const diff = this.scrollHeight - window.pageYOffset;
                this.isBackTopFooter = diff < (this.scrollIndentBackTop - 40 - 15);
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "../../common/styles/_colors.scss";
    @import "../../common/styles/_responsive.scss";

    .back-to-top-fade-enter-active,
    .back-to-top-fade-leave-active {
        transition: opacity .6s;
    }

    .back-to-top-fade-enter,
    .back-to-top-fade-leave-to {
        opacity: 0;
    }

    .vue-back-to-top {
        cursor: pointer;
        position: fixed;
        z-index: 1000;
        background-repeat: none;

        .circle-button {
            background-color: rgba($ypo-blue, 0.6);
            border-radius: 50%;
            color: $white;
            height: 40px;
            line-height: 42px;
            text-align: center;
            width: 40px;
            transition: 0.3s all ease;

            &:hover {
                background-color: $ypo-blue;
            }

            i {
                font-size: 18px;
            }
        }
        @include breakpoint(xs) {
            display: none;
        }
    }
</style>
